import { useState, useCallback } from 'react';

function useViewState() {
  const [view, setView] = useState();
  const onViewCreated = useCallback((view2) => {
    setView(view2);
  }, []);
  return [view, onViewCreated];
}

export { useViewState };
